/**
 * Persist the user's explicitly-chosen site/language preference across page
 * navigations within the same session.
 *
 * Uses sessionStorage so the preference resets when the browser tab is closed
 * (appropriate — a new tab or share link should re-detect language from the
 * URL / browser settings rather than inheriting a stale tab preference).
 */

const KEY = "dgl-preferred-site-id";

export function savePreferredSiteId(siteId) {
  if (typeof sessionStorage === "undefined") return;
  try { sessionStorage.setItem(KEY, String(siteId)); } catch { /* quota / private mode */ }
}

export function loadPreferredSiteId() {
  if (typeof sessionStorage === "undefined") return null;
  try { return sessionStorage.getItem(KEY) || null; } catch { return null; }
}
